import { SearchUserHit } from 'lib-shared-types-api';
import { connect } from 'react-redux';

import { transformSearchUserToUser } from 'apis/users';
import { RootReducerStateT } from 'app/reducers/rootReducer';
import { AppDispatch } from 'bootstrap.store';
import { AddUserPayload, userModalActions } from 'components/usersModal';
import { withCountries, WithCountriesInjectedProps } from 'hocs';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../../app/middleware/twilio/actions/twilioActions';
import { actions } from '../../../telephony/actions/telephony';
import { TelephonySearchUser } from '../components/SearchUser/SearchUser';

const mapStateToProps = (state: RootReducerStateT) => {
  return {
    ui: state.telephony.ui,
    meta: state.telephony.meta,
    telephonyMeta: state.twilio.meta,
    selectedFromNumber: state.telephony.selectedFromNumber,
    currentCall: state.telephony.currentCall,
    users: state.telephony.users,
    dynamicTelephoneNumbersArray: state.telephony.dynamicTelephoneNumbersArray,
    staticTelephoneNumbersArray: state.telephony.staticTelephoneNumbersArray,
    profile: state.settings.profile.profile,
    searchValue: state.telephony.searchValue,
    isOnTrial:
      typeof state.settings.organization.organization.trial_ended_at ===
      'string'
        ? false
        : true,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    resetUsers: () => dispatch(actions.telephonyResetUsers()),
    editUser: (user: SearchUserHit) =>
      dispatch(
        userModalActions.show({ user: transformSearchUserToUser(user) }),
      ),
    setSearchUserValue: (payload: string) =>
      dispatch(actions.telephonySetSearchValue(payload)),
    userModalAddUser: (payload: AddUserPayload) =>
      dispatch(userModalActions.user.add(payload)),
    getUsersByQuery: bindActionToPromise(
      dispatch,
      actions.telephonyGetUsersByQuery,
    ),
    telephonySetBlocked: () => dispatch(actions.telephonyResetUsers()),
    telephonyMakeCall: bindActionToPromise(
      dispatch,
      twilioActions.twilioMakeCall,
    ),
  };
};

type SearchUserStateProps = ReturnType<typeof mapStateToProps>;
type SearchUserDispatchProps = ReturnType<typeof mapDispatchToProps>;

export type SearchUserInjectedProps = SearchUserStateProps &
  SearchUserDispatchProps &
  WithCountriesInjectedProps;

const SearchUserWithCountries = withCountries(TelephonySearchUser);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchUserWithCountries);
